// extracted by mini-css-extract-plugin
export default {"editBtn":"EditBtn_editBtn__CPCxr","editIcon":"EditBtn_editIcon__buc4b","editBtnText":"EditBtn_editBtnText__zzLPb"};